import React from 'react'
import { Divider, DividerColors } from 'atoms/Divider'

interface IContainerWithDividersProps {
  children: React.ReactNode
  Container: React.ComponentType<{ children: React.ReactNode }>
  isWithDivider?: 0 | 1
  dividerClassName?: string
}

export const ChildrenWithDividers = ({
  children,
  Container,
  isWithDivider = 1,
  dividerClassName,
}: IContainerWithDividersProps) => {
  const childrenArray = React.Children.toArray(children)

  if (childrenArray.length <= 1) {
    return <Container>{children}</Container>
  }

  const childrenWithDividers = childrenArray.reduce(
    (acc: React.ReactNode[], child, index) => {
      acc.push(child)

      if (isWithDivider && index < childrenArray.length - 1) {
        acc.push(
          <Divider
            width='100%'
            height='1px'
            background={DividerColors.SURFACE_OPACITY_LIGHT_10}
            key={`divider-${index}`}
            className={dividerClassName}
          />
        )
      }

      return acc
    },
    []
  )

  return <Container>{childrenWithDividers}</Container>
}
